<template>
	<div class="row">
		<div class="col-12">
			<VimeoPlayer :video-url="activity.embed" />
		</div>
	</div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player'
export default {
	name: 'WebinarVimeoPlayer',

	props: ['activity'],

	components: {
		VimeoPlayer: vueVimeoPlayer,
	},

	created() {
		this.$emit('startWebinar', this.activity)
	},

	beforeDestroy() {
		this.$mitt.emit('setUserOfflineFirebase', this.activity)
	},
}
</script>

<style lang="scss">
iframe {
	width: 100%;
	height: 40vh;
}
</style>
